module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress_number_4.619ac467.svg";